import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { siteInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="text-2xl font-bold text-white">
              NOBEL<span className="text-blue-500">RIJSCHOOL</span>
            </div>
            <p className="text-sm">
              De beste rijschool in de regio. Snel, professioneel en met persoonlijke aandacht.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-blue-500 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-blue-500 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Snelle Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-blue-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/over-ons" className="text-sm hover:text-blue-500 transition-colors">
                  Over Ons
                </Link>
              </li>
              <li>
                <Link to="/cursussen" className="text-sm hover:text-blue-500 transition-colors">
                  Cursussen
                </Link>
              </li>
              <li>
                <Link to="/tarieven" className="text-sm hover:text-blue-500 transition-colors">
                  Tarieven
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Onze Diensten</h3>
            <ul className="space-y-2">
              <li className="text-sm">Standaard Rijlessen</li>
              <li className="text-sm">Intensieve Cursus</li>
              <li className="text-sm">Automaat Rijlessen</li>
              <li className="text-sm">Faalangst Begeleiding</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{siteInfo.email}</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Nobel Rijschool. Alle rechten voorbehouden.
          </p>
          <p className="text-xs mt-2 text-gray-500">KVK: {siteInfo.kvk}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;